import { FC, useContext, useMemo, useState } from "react";
import { useLogger } from "cayo.ui";
import { AppContext } from "@cayo/shared/components/App/appContext";
import { ClientWizardsHolder } from "./ClientWizardsHolder";
import InitialConfigurationWizard from "../Configuration/InitialConfigurationWizard";
import WizardsSchemeHolder from "../Schemes/WizardScheme/WizardsSchemeHolder";

type WizardStuffProps = { isLoggedIn?: boolean };

export const WizardStuff: FC<WizardStuffProps> = ({ isLoggedIn }) => {
  const [isWizardOpened, setIsWizardOpened] = useState(false);
  const log = useLogger("WizardStuff");

  const { manifest } = useContext(AppContext);

  const showInitialConfig = useMemo(() => {
    const hideInitialConfig = import.meta.env.REACT_APP_HIDE_INITIAL_CONFIG;
    if (hideInitialConfig) {
      return false;
    }

    const initialConfigDisabled =
      manifest?.client_config?.features &&
      manifest.client_config.features["initialConfig"] === "disabled";

    const result = !!manifest?.name && !initialConfigDisabled;

    log.debug("showInitialConfig", result);
    return result;
  }, [manifest]);

  return (
    <>
      <WizardsSchemeHolder onWizardAction={setIsWizardOpened} />
      <ClientWizardsHolder onWizardAction={setIsWizardOpened} />
      {showInitialConfig && (
        <InitialConfigurationWizard isLoggedIn={isLoggedIn} isVisible={!isWizardOpened} />
      )}
    </>
  );
};
